import React from 'react';
import { Navigate, useParams, useSearchParams } from 'react-router-dom';
import { toSportSlug } from '@utils/sports';

/** Redirect legacy self-evaluation route to in-page tab on the sport contest page. */
const ContestSelfEvaluationPage: React.FC = () => {
  const { sport: sportSlug } = useParams<{ sport: string }>();
  const [searchParams] = useSearchParams();
  const slug = toSportSlug(sportSlug || 'badminton');
  const age = searchParams.get('age');
  const query = new URLSearchParams({ tab: 'self-evaluation' });
  if (age) query.set('age', age);
  return <Navigate to={`/contests/${slug}?${query.toString()}`} replace />;
};

export default ContestSelfEvaluationPage;
